import { useContext } from 'react';
import { ToastContext } from '@components';

// ToastProvider.tsx의 ToastContext에서 제공하는 showToast 함수에 접근할 수 있게 해주는 커스텀 훅
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
